// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"CategoryListCard_productDetailHeader__kCAlG","icons":"CategoryListCard_icons__VZGvP"};